"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaddedContainer = void 0;
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const PaddedContainer_styled_1 = require("./PaddedContainer.styled");
const PaddedContainer_types_1 = require("./PaddedContainer.types");
function PaddedContainer({ children, padding = PaddedContainer_types_1.PaddedContainerSize.None }) {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const [paddingSize, setPadding] = (0, react_1.useState)(theme.typography.desktop.text.medium_default['font-size'].value);
    (0, react_1.useEffect)(() => {
        switch (padding) {
            case PaddedContainer_types_1.PaddedContainerSize.Micro: {
                setPadding(theme.sizes['2xs'].value);
                break;
            }
            case PaddedContainer_types_1.PaddedContainerSize.Tiny: {
                setPadding(theme.sizes.s.value);
                break;
            }
            case PaddedContainer_types_1.PaddedContainerSize.XSmall: {
                setPadding(theme.sizes.m.value);
                break;
            }
            case PaddedContainer_types_1.PaddedContainerSize.Small: {
                setPadding(theme.sizes.l.value);
                break;
            }
            case PaddedContainer_types_1.PaddedContainerSize.Medium: {
                setPadding(theme.sizes.xl.value);
                break;
            }
            case PaddedContainer_types_1.PaddedContainerSize.Large: {
                setPadding(theme.sizes['2xl'].value);
                break;
            }
            case PaddedContainer_types_1.PaddedContainerSize.XLarge: {
                setPadding(theme.sizes['3xl'].value);
                break;
            }
            default: {
                setPadding('0');
                break;
            }
        }
    }, [padding, theme]);
    return (react_1.default.createElement(PaddedContainer_styled_1.StyledPaddedContainer, { padding: paddingSize, theme: theme }, children));
}
exports.PaddedContainer = PaddedContainer;
//# sourceMappingURL=PaddedContainer.js.map